import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { authorization } from "../authorization";
import { initialCountry, filteredCountry } from "../store/actions";

import { Container, Row, Col, Form, Input, Button, Table } from "reactstrap";

const WorldStats = () => {
  const [worldStats, setWorldStats] = useState({});
  const [search, setSearch] = useState(null);
  const [topTen, setTopTen] = useState(null);
  const singleStat = useSelector((state) => state.allstats);
  const [cuntryData, setCountryData] = useState(null);
  const [suggest, setSuggest] = useState();
  const [visibility, setVisibility] = useState(true);
  const dispatch = useDispatch();
  const inputRef = useRef();

  let countryData = singleStat;
  let countryName = useRef(null);
  let top10 = countryData ? [...countryData.allData] : null;
  const config = {
    headers: authorization,
  };

  useEffect(() => {
    let lat, lon;

    //Geolocation
    const Geolocation = () => {
      const showposition = (position) => {
        lat = position.coords.latitude.toString();
        lon = position.coords.longitude.toString();
        axios
          .get(`https://geocode.xyz/${lat},${lon}?json=1`)
          .then((response) => {
            countryName.current = response.data.country;
            getCountryData("", countryName.current);
          })
          .catch((error) => {
            getCountryData("", null);
          });
      };
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showposition);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    };
    Geolocation();
    // getCountryData("");

    //Starting World Stats
    axios
      .get(
        "https://coronavirus-monitor.p.rapidapi.com/coronavirus/worldstat.php",
        config
      )
      .then((response) => {
        setWorldStats(response.data);
      });
  }, []);

  //On Form Submit
  const submitHandler = (e) => {
    setVisibility(false);
    e.preventDefault();
    getCountryData(search);
  };

  //Filtered Data
  const getCountryData = (query, countryName) => {
    const searchQuery = query.length == 0 ? null : query;

    const countryname = countryName;
    axios
      .get(
        "https://coronavirus-monitor.p.rapidapi.com/coronavirus/cases_by_country.php",
        config
      )
      .then((response) => {
        setCountryData(response.data);
        searchQuery
          ? dispatch(filteredCountry(response.data, searchQuery))
          : dispatch(initialCountry(response.data, countryname));
      });
  };

  //Autosuggest

  const autoSuggestList = (event) => {
    setSearch(event.target.value);
    setVisibility(true);
    let qur = new RegExp(search ? search.toLowerCase() : "", "g");

    console.log("executed");
    const listData = cuntryData
      ? cuntryData.countries_stat
          .map((item) => {
            if (item.country_name.toLowerCase().match(qur)) {
              return item.country_name;
            } else {
              return null;
            }
          })
          .filter((ct) => ct !== null)
      : null;
    if (listData.length === 0) {
      setVisibility(false);
    }
    setSuggest(listData);
  };

  return (
    <div>
      <h1 className="text-center my-4">World Stats</h1>
      <div className="stats-wrapper">
        <Container>
          <Row className="world-stats py-4">
            <Col md="4">
              <h2>Total Cases</h2>
              <h3>{worldStats ? worldStats.total_cases : "-"} </h3>
            </Col>
            <Col md="4">
              <h2>Total Deaths</h2>
              <h3>{worldStats ? worldStats.total_deaths : "-"} </h3>
            </Col>
            <Col md="4">
              <h2>Total Recovered</h2>
              <h3>{worldStats ? worldStats.total_recovered : "-"} </h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="searchbar">
        <Form
          inline
          onSubmit={submitHandler}
          className="d-flex justify-content-center"
        >
          <Input
            type="text"
            placeholder="Enter your country..."
            value={search}
            onChange={(event) => autoSuggestList(event)}
            onClick={() => setSearch(null)}
            innerRef={inputRef}
            required
          />
          <Button color="primary" className="h-100">
            Search
          </Button>
        </Form>
        <div className="autosuggest-wrapper">
          <div className="auto-suggest-box">
            <ul
              className={`country-list ${search ? "displayOn" : "displayOff"} ${
                visibility ? "displayOn" : "displayOff"
              }`}
            >
              {suggest && suggest.length > 0
                ? suggest.map((item) => (
                    <li
                      onClick={() => {
                        setSearch(item.toLowerCase());
                        setVisibility(false);
                        inputRef.current.focus();
                      }}
                      key={item}
                    >
                      {item}
                    </li>
                  ))
                : null}
            </ul>
          </div>
        </div>
      </div>

      <div className="search-results container-fluid">
        <Row>
          {countryData && countryData.allstats.length > 0 ? (
            countryData.allstats.map((ct) => (
              <Col md="4" key={ct.country_name} className="text-center">
                <div className="country-stats py-4 px-3">
                  <h2>{ct.country_name}</h2>
                  <h3>Total Cases: {ct.cases}</h3>
                  <h3>Active Cases: {ct.active_cases}</h3>
                  <h3>Total Deaths: {ct.deaths}</h3>
                  <h3>Recovered: {ct.total_recovered}</h3>
                </div>
              </Col>
            ))
          ) : (
            <h2 className="country-center mt-2">
              Country not found or check the spelling
            </h2>
          )}
        </Row>
      </div>

      <div className="container-fluid mt-5 mb-5">
        <h3 className="text-center">Top 10 Countries</h3>

        <Table striped responsive className="mb-5">
          <thead>
            <tr>
              <th>Country Name</th>
              <th>Total Cases</th>
              <th>Active Cases</th>
              <th>Deaths</th>
              <th>Recovered</th>
            </tr>
          </thead>
          <tbody>
            {top10
              ? top10.map((topcountry, index) =>
                  index < 10 ? (
                    <tr key={topcountry.state}>
                      <td>{topcountry.country_name}</td>
                      <td>{topcountry.cases}</td>
                      <td>{topcountry.active_cases}</td>
                      <td>{topcountry.deaths}</td>
                      <td>{topcountry.total_recovered}</td>
                    </tr>
                  ) : (
                    false
                  )
                )
              : null}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default WorldStats;
